import tw, { styled } from "twin.macro";

export const StyledApp = styled.div`
  & {
    font-family: "Montserrat", sans-serif;
  }
`;
